import React from 'react';
import axios2 from 'services/axios2';
import { ToastContainer, toast } from 'react-toastify';


import { withRouterJim } from "router/withRouterJim"; 
import NuAlert2 from 'components/NuAlert2';
import NuLoading from 'components/nubox/NuLoading';

import { Link } from "react-router-dom";
//import '../App.css';
import logo from 'assets/logo.png';
import { Button } from 'bootstrap/dist/js/bootstrap.bundle.min';
import { StrikethroughS } from '@material-ui/icons';



const initialForm = {
  idd:0,
  ope:'n',
  
  id_est:0,
  nro_doc:"",
  nomape_tmp:"",
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class KardexEst extends React.Component {

  myRef = React.createRef();//create ref
  nuRef = React.createRef();//create ref

  state = {

    
    cargando:false,
    id_est:0,

    form: { },
    dataList: [],/* lista  */
    
    
  };

  //-----------------------------------------------

  //------------------------------------------------------
  componentDidMount() {
    console.log("componentDidMount citas");
    //--limpiamos el array de prueba
    this.setState({ data: [] });

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //-----------------parametro de afuera
    let id_est = this.props.params.id;    
    this.setState({ id_est: id_est });

    this.cargar_data(id_est)
  }

  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  //====================================================== 
  cargar_data = (id_est) => {
    //let id_mate = this.props.store.materia.id_mate

    let param = { 
      id_est: id_est
    }
    this.setState({ cargando: true })
    axios2.post( 'kardex_est_get_list', param)
    .then(res => {
        console.log(res.data);

        this.setState({ cargando: false })
        //const array = JSON.parse(res.data);
        if(res.data.tabla.length>0){
          this.setState({ form: res.data.form });
          this.setState({ dataList: res.data.tabla });
        }else{
          //----no existen datos
          this.nuRef.current.show({'type':'error',"text":"No existen datos" });
          this.setState({ form: {} });
          this.setState({ dataList: [] });
        }
        

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });
  };
  //====================================================== 
  //====================================================== 
    
  //-------------------------------------

  render() {
    let form = this.state.form
    let user = this.props.store.user
    return (
      <div>
        <ToastContainer />
        <div className="content">
          {
            //JSON.stringify(this.state.form1)
          }
          <h3 className="box-title">
            <strong>SEGUIMIENTO ACADEMICO "KARDEX"</strong>
          </h3>


          <NuLoading className="oso" show={this.state.cargando} text="Cargando..." />
          <br />
          <NuAlert2 ref={this.nuRef} />
          <table className='' >
            <tbody>  
              <tr >
                <td>Cod.Est.</td>
                <td>{ form.id_est  }</td>
              </tr>
              <tr >
                <td>Nro. Doc.</td>
                <td>{ form.nro_doc  }</td>
              </tr>
              <tr >
                <td><b>Nombre estudiante</b></td>
                <td>{ form.nomape_tmp  }</td>
              </tr>
            </tbody>
          </table>

          <table className='' style={{backgroundColor: 'white'}}>
            <thead>
              <th>Sigla</th>
              <th>Materia</th>
              <th>Grupo</th>
              <th>Nota final</th>
              <th>Literal</th>
              <th>Obs.</th>
            </thead>
            <tbody>
              { this.state.dataList.map((item, index) => (
                <tr key={index}>
                  <td>{ item.sigla }</td>
                  <td>{ item.nombre }</td>
                  <td className='text-center' >{ item.id_grupo }</td>
                  <td className='text-center'>{ item.nota_final }</td>
                  <td> </td>
                  <td>{ item.obs }</td>
                </tr>
              ))}       
            </tbody>
          </table>

        </div>


      </div>
    );
  }
}

export default withRouterJim(KardexEst);